export function mainMenu() {
  const topSection   = document.querySelector('.wp-block-site-logo');
  const header       = document.querySelector('header.wp-block-template-part');
  const megaMenu     = document.querySelectorAll('.megamenu');
  const megaMenuItem = document.querySelectorAll('.has-wlc-mega-menu');
  const searchButtonToggle = document.querySelector('.gence-search-button');
  const nativeSearchButton = document.querySelector('.gence-search-wrapper .wp-block-search__button');
  const mobileLangSwitcher = document.querySelector('.mobile-lang-switcher .wp-block-navigation-item__content');
  const mobilelangSwitcherClose = document.querySelector('.header__top-lang-btns .wp-element-button');

  const hamburger = document.createElement('div');
  hamburger.className = 'header__hamburger-button';

  const closeMenu = document.createElement('div');
  closeMenu.className = 'header__close-menu';

  hamburger.addEventListener('click', () => {
    const chatBox    = document.querySelector('.zsiq_floatmain');
    header.classList.add('active-menu');
    if (chatBox) {
      chatBox.style.display = 'none';
    }
    topSection.removeChild(hamburger);
    topSection.prepend(closeMenu);
  });

  closeMenu.addEventListener('click', () => {
    header.classList.remove('active-menu');
    topSection.prepend(hamburger);
    topSection.removeChild(closeMenu);
  });

  megaMenuItem?.forEach(item => {
    const menuLabel = item.querySelector('.wp-block-navigation-item__label');
    const mobileMenu = item.querySelector('.megamenu');

    const mobileTitle = document.createElement('div');
    mobileTitle.className = 'megamenu__mobile-title';
    mobileTitle.innerHTML = menuLabel.innerHTML;

    mobileMenu?.prepend(mobileTitle);
  });


  megaMenu?.forEach(menu => {
    const mobileMenuToggle = menu.querySelectorAll('.megamenu__menu-block p');
    mobileMenuToggle?.forEach((item, key) => {
      const navigation = item.nextElementSibling;
      
      item.classList.add('active');
      navigation.classList.add('active');

      item.addEventListener('click', () => {
        navigation.classList.toggle('active');
        item.classList.toggle('active');
      })
    });
  });

  topSection.prepend(hamburger);
  
  if (nativeSearchButton) {
    nativeSearchButton.innerHTML = '';
  }
  
  searchButtonToggle?.addEventListener('click', () => {
    const searchForm = document.querySelector('.gence-search-wrapper');
    searchForm.classList.toggle('active');
    searchButtonToggle.classList.toggle('open');
  });
  
  mobileLangSwitcher?.addEventListener('click', (e) => {
    e.preventDefault();
    header.classList.add('mobile-lang-switcher-active');
  });

  mobilelangSwitcherClose?.addEventListener('click', (e) => {
    e.preventDefault();
    header.classList.remove('mobile-lang-switcher-active');
  });
}